import { configureStore } from '@reduxjs/toolkit';
import auth from './slices/authSlice';
import theme from './slices/themeSlice';

export const store = configureStore({
  reducer: { auth, theme },
});
